<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <h3>O&M Permit Annual Renewal Application</h3>
    <expanded-fieldset title="Project Types">
      <div class="row">
        <div class="col">
          <label v-model="form.OMProjectTypeList">
               Type of Project: (Check all that apply)
          </label>
          <base-checkbox v-model="form.omFriableSchoolProjectType"
                         label="Friable School Project"
                         :validation="$v.form.friableSchool"/>
          <base-checkbox v-model="form.omNonFriableSchoolProjectType"
                         label="Non-Friable School Floor Tile Project"
                         :validation="$v.form.nonFriableSchool"/>
          <base-checkbox v-model="form.omCommercialProjectType"
                         label="Commercial Public building (Friable & Non-Friable)"
                         :validation="$v.form.commercialPublic"/>
        </div>
        <div class="col">
          <label class="required" v-model="form.OMSubmittedList"
              :validation="$v.form.OMSubmittedList">
              Submitted by:
          </label>
          <base-checkbox v-model="form.submitter.contractor"
                         label="Contractor"
                         :validation="$v.form.submitter.contractor"
                         v-on:click="setBoxes('contractor')" />
          <base-checkbox v-model="form.submitter.owner"
                         label="Owner"
                         :validation="$v.form.submitter.owner"
                         v-on:click="setBoxes('owner')" />
          <base-checkbox v-model="form.submitter.projectDesigner"
                         label="Project Designer"
                         :validation="$v.form.submitter.projectDesigner"
                         v-on:click="setBoxes('projectDesigner')" />
        </div>
      </div>
    </expanded-fieldset>
    <expanded-fieldset title="Email Address">
      <base-input v-model="form.contactEmail"
                  label="Email Address (for permit to be sent to)"
                  :validation="$v.form.contactEmail" />
      <base-input v-model="form.confirmEmail"
                  label="Verify Email Address"
                  :validation="$v.form.confirmEmail" />
    </expanded-fieldset>
    <expanded-fieldset title="Facility Information">
      <base-input v-model="form.facility.name"
                  label="Facility Name"
                  :readonly="true"
                  :validation="$v.form.facility.name" />

      <v-address v-model="form.facility.address"
                 :readonly="true"
                 :validation="$v.form.facility" />
      <!--
    <dl class="row">
      <dt class="col-sm-3">Facility Name:</dt>
      <dd class="col-sm-9">{{facility.name}}</dd>
      <dt class="col-sm-3">Street Address:</dt>
      <dd class="col-sm-9">
        {{facility.address.streetNumber}}
        {{facility.address.streetDirection}}
        {{facility.address.streetName}}
        {{facility.address.streetType}}
        {{facility.address.suffixDir}}
      </dd>
      <dt class="col-sm-3">Street Address (Line 2):</dt>
      <dd class="col-sm-9">
        {{facility.address.addressLine2}}
      </dd>
      <dt class="col-sm-2">City:</dt>
      <dd class="col-sm-2">{{facility.address.city}}</dd>
      <dt class="col-sm-2">State:</dt>
      <dd class="col-sm-2">{{facility.address.state}}</dd>
      <dt class="col-sm-2">Zip:</dt>
      <dd class="col-sm-2">{{facility.address.zipCode}}</dd>
    </dl>
  -->
      <div class="row">
        <div class="col">
          <base-input v-model="form.facility.contactName"
                      label="Facility Contact Name"
                      :validation="$v.form.facility.contactName" />
        </div>
        <div class="col">
          <base-input v-model="form.facility.contactPhone"
                      label="Facility Contact Phone"
                      :validation="$v.form.facility.contactPhone"
                      mask="(###)-###-####"
                      type="tel" />
        </div>
        <div class="col">
          <base-input v-model="form.facility.contactEmail"
                      label=" Facility Contact Email"
                      :validation="$v.form.facility.contactEmail" />
        </div>
      </div>
    </expanded-fieldset>
    <expanded-fieldset title="Facility Owner Information">
      <base-input v-model="form.facility.contact"
                  label="Facility Owner or School District"
                  :validation="$v.form.facility.contact" />
      <v-address v-model="form.facility.ownerAddress"
                   labelPrefix="Owner Address"
                   :validation="$v.form.facility.ownerAddress"
                   :show-unincorporated="false"/>
      <div class="row">
        <div class="col">
          <base-input v-model="form.facility.contactName"
                      label="Facility Owner Contact Name"
                      :validation="$v.form.facility.contactName" />
        </div>
        <div class="col">
          <base-input v-model="form.facility.phone"
                      label="Facility Owner Contact Phone"
                      :validation="$v.form.facility.phone"
                      mask="(###)-###-####"
                      type="tel" />
        </div>
        <div class="col">
          <base-input v-model="form.facility.email"
                      label=" Facility Owner Contact Email"
                      :validation="$v.form.facility.email" />
        </div>
      </div>
    </expanded-fieldset>
    <expanded-fieldset title="Contractor Information">
      <div class="row">
        <div class="col">
          <label class="required">Asbestos Contractor Name</label>
          <vue-simple-suggest v-model="form.contractor.name"
                              :list="contractors"
                              :validation="$v.form.contractor.name"
                              pattern="\w+"
                              mode="input"
                              placeholder="Asbestos Contractor Name"
                              value-attribute="id"
                              display-attribute="name"
                              @select="contractorSelected"
                              :filter-by-query="true" />
        </div>
        <div class="col">
          <base-input v-model="form.contractor.contractorIDPH"
                      :readonly="true"
                      label="IDPH Number" />
        </div>
      </div>
      <hr />
      <v-address v-model="form.contractor.address"
                 :readonly="true"
                 :validation="$v.form.contractor.address"
                 labelPrefix="Contractor" />
      <hr />
      <div class="row">
        <div class="col">
          <base-input v-model="form.contractorContactFirstName"
                      label="Contractor First Name"
                      placeholder="First Name"
                      :readonly="false"
                      :validation="$v.form.contractorContactFirstName" />
        </div>
        <div class="col">
          <base-input v-model="form.contractorContactLastName"
                      label="Contractor Last Name"
                      placeholder="Last Name"
                      :readonly="false"
                      :validation="$v.form.contractorContactLastName" />
        </div>
        <div class="col">
          <base-input v-model="form.contractorContactPhone"
                      label="Contractor Phone"
                      type="tel"
                      :readonly="false"
                      placeholder="(xxx)-xxx-xxxx"
                      mask="(###)-###-####"
                      :validation="$v.form.contractorContactPhone" />
        </div>
        <div class="col">
          <base-input v-model="form.contractorContactEmail"
                      label="Contractor Email"
                      type="email"
                      :readonly="false"
                      placeholder="name@company.com"
                      :validation="$v.form.contractorContactEmail" />
        </div>
      </div>
    </expanded-fieldset>
    <expanded-fieldset title="Disposal Site/Landfill Information">
      <base-input v-model="form.disposalSite.name"
                  label="Disposal Site/Landfill Name"
                  :validation="$v.form.disposalSite.name" />
      <div class="row">
        <div class="col">
          <base-input v-model="form.disposalSite.contact"
                      label="Disposal Site Contact Name"
                      placeholder="Contact Name"
                      :readonly="false"
                      :validation="$v.form.disposalSite.contact" />
        </div>
        <div class="col">
          <base-input v-model="form.disposalSite.phone"
                      label="Disposal Site Phone"
                      type="tel"
                      :readonly="false"
                      placeholder="(xxx)-xxx-xxxx"
                      mask="(###)-###-####"
                      :validation="$v.form.disposalSite.phone" />
        </div>
        <div class="col">
          <base-input v-model="form.disposalSite.email"
                      label="Disposal Site Email"
                      type="email"
                      :readonly="false"
                      placeholder="name@company.com"
                      :validation="$v.form.disposalSite.email" />
        </div>
      </div>
    </expanded-fieldset>
    <expanded-fieldset title="Waste Transporter Information">
      <base-input v-model="form.transporter.name"
                  label="Waste Transporter Name"
                  :validation="$v.form.transporter.name" />
      <div class="row">
        <div class="col">
          <base-input v-model="form.transporter.contact"
                      label="Disposal Site Contact Name"
                      placeholder="Contact Name"
                      :readonly="false"
                      :validation="$v.form.transporter.contact" />
        </div>
        <div class="col">
          <base-input v-model="form.transporter.phone"
                      label= "Waste Transporter Phone"
                      type="tel"
                      :readonly="false"
                      placeholder="(xxx)-xxx-xxxx"
                      mask="(###)-###-####"
                      :validation="$v.form.transporter.phone" />
        </div>
        <div class="col">
          <base-input v-model="form.transporter.email"
                      label="Disposal Site Email"
                      type="email"
                      :readonly="false"
                      placeholder="name@company.com"
                      :validation="$v.form.transporter.email" />
        </div>
      </div>
    </expanded-fieldset>
    <expanded-fieldset title="Permit Date Information">
      <base-date-picker v-model="form.permitStartDate"
                        label="O&M Permit Start Date (not project start date):"
                        :validation="$v.form.permitStartDate" />
    </expanded-fieldset>

    <expanded-fieldset title="School Contractor Information" v-if="form.facility.type == 'School' && form.omPermit == true">
      <div class="row">
        <div class="col">
          <label class="required">Project Designer Name</label>
          <base-input v-model="form.projectDesignerName"
                      placeholder="Project Designer Name"
                      v-if="form.facility.type == 'School' && form.omPermit == true"
                      :validation="$v.form.projectDesignerName" />
        </div>
        <div class="col">
          <label class="required">IDPH Number</label>
          <base-input v-model="form.projectDesignerId"
                      placeholder="IDPH Number"
                      v-if="form.facility.type == 'School' && form.omPermit == true"
                      :validation="$v.form.projectDesignerId"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="required">Asbestos Project Manager Name</label>
          <base-input v-model="form.asbestosProjectManagerName"
                      placeholder="Asbestos Project Manager Name"
                      v-if="form.facility.type == 'School' && form.omPermit == true"
                      :validation="$v.form.asbestosProjectManagerName" />
        </div>
        <div class="col">
          <label class="required">IDPH Number</label>
          <base-input v-model="form.asbestosProjectManagerId"
                      placeholder="IDPH Number"
                      v-if="form.facility.type == 'School' && form.omPermit == true"
                      :validation="$v.form.asbestosProjectManagerId" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="required">Air Sampling Professional Name</label>
          <base-input v-model="form.airSamplingProfessionalName"
                      placeholder="Air Sampling Professional Name"
                      v-if="form.facility.type == 'School' && form.omPermit == true"
                      :validation="$v.form.airSamplingProfessionalName" />
        </div>
        <div class="col">
          <label class="required">IDPH Number</label>
          <base-input v-model="form.airSamplingProfessionalId"
                      placeholder="IDPH Number"
                      v-if="form.facility.type == 'School' && form.omPermit == true"
                      :validation="$v.form.airSamplingProfessionalId" />
        </div>
      </div>
    </expanded-fieldset>
    <expanded-fieldset title="Signatures">
      <base-date-picker v-model="form.submissionDate"
                        label="Submission Date"
                        :validation="$v.form.submissionDate" />
      <base-input v-model="form.submitterName"
                  label="Signature"

                  :validation="$v.form.submitterName" />
    </expanded-fieldset>
    <div>
      <button type="button"
              class="btn btn-secondary"
              @click="cancel">
        Back
      </button>
      <button type="button"
              class="btn btn-primary"
              @click="checkout">
        Checkout
      </button>
    </div>
  </div>

</template>

<script>
import { Facility, OAndMRenewalApplication, Contractor } from '@/js/FormObjects';
import { getOMFacility, getContractors } from '@/js/FormFunctions';
import { OAndMRenewalApplicationValidation } from '@/js/FormValidations';
import BaseCheckbox from '@/components/BaseCheckbox';
import ExpandedFieldset from '@/components/ExplodedFieldset';
import BaseInput from '@/components/BaseInput';
import VAddress from '@/components/VAddress';
import VueSimpleSuggest from 'vue-simple-suggest';
import BaseDatePicker from '@/components/BaseDatePicker';

export default {
  name: 'RenewalApplication',
  props: ['facilityId'],
  components: {
    BaseDatePicker,
    VAddress,
    BaseInput,
    ExpandedFieldset,
    BaseCheckbox,
    VueSimpleSuggest,
  },
  data() {
    return {
      fetchingData: false,
      form: new OAndMRenewalApplication(),
      facility: new Facility(),
      // contractor: new Contractor('asbestos'),
      contractors: [],
    };
  },
  mounted() {
    const vm = this;
    this.fetchingData = true;
    this.form.permitStartDate.setDate(this.form.permitStartDate.getDate() + 2);
    getContractors('asbestos')
      .then((data) => {
        vm.fetchingData = false;
        vm.contractors = data;
      })
      .catch(() => {
        vm.fetchingData = false;
      });

    getOMFacility(this.facilityId)
      .then((facility) => {
        vm.fetchingData = false;
        vm.facility = facility;
        vm.form.facility = facility;
      })
      .catch(() => {
        vm.fetchingData = false;
      });
  },
  validations: {
    form: new OAndMRenewalApplicationValidation(),
  },
  methods: {
    contractorSelected(contractor) {
      this.form.contractor = contractor;
    },
    setBoxes(checked) {
      if (checked == 'contractor') {
        this.form.submittersTitle = 'Contractor';
        this.form.submitter.owner = false;
        this.form.submitter.projectDesigner = false;
      } else if (checked == 'owner') {
        this.form.submittersTitle = 'Owner';
        this.form.submitter.contractor = false;
        this.form.submitter.projectDesigner = false;
      } else if (checked == 'projectDesigner') {
        this.form.submittersTitle = 'Project Designer';
        this.form.submitter.contractor = false;
        this.form.submitter.owner = false;
      }
    },
    checkout() {
      const self = this;

      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$notify('Errors during permit application validation.', 'error');
        return;
      }

      const formData = new FormData();
      /*
      Object.keys(this.application.files).forEach((key) => {
        if (self.application.files[key]) {
          formData.append(key, self.application.files[key])
        }
      })
     */
      this.form.projectType = 'asbestos';
      this.form.omPermit = true;
      // this.form.facility = this.facility
      formData.append('form', JSON.stringify(this.form));
      this.fetchingData = true;
      self.$http.post('/api/permit/save', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          self.fetchingData = false;
          this.$router.push({ name: 'Checkout', query: { permitId: response.data } });
        })
        .catch((error) => {
          console.error(error);
          self.fetchingData = false;
          self.$notify('Error saving application record', 'error');
        });
    },
    cancel() {
      this.$store.commit('temporaryForm', this.application);
      this.$router.push({
        name: 'PermitApplication',
        params: {
          projectType: this.projectType,
        },
        query: {
          applicationNumber: this.application.id,
        },
      });
    },
  },
};
</script>

